<script>
import AthleteTable from "./components/AthleteTable.svelte";
import HFWrap from "./components/HFWrap.svelte";
import Input from "./components/Input.svelte";
import "./styles.css";

let lenex;
</script>
<style>
  main {
    display: flex;
    font-family: sans-serif;
    flex-direction: column;
  }

  footer {
    display: flex;
    justify-content: space-between;
    font-size: 0.8rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: calc(100vw - 2rem);
    padding: 0rem 1rem;
  }
</style>

<HFWrap>
<main class="container">
  {#if lenex}
    <h1 class="title">{lenex?.rawLenexData?.meets?.[0]?.name}</h1>
  {:else} 
    <h1>Splits-sheet Creator</h1>
    <p>Please open a lenex (.lxf, .lef) file containing the meet entries.</p>
  {/if}
  <div>
    <Input bind:lenex={lenex}/>
    {#if lenex}
    <button on:click={() => window.print()}>Print</button>
    {/if}
  </div>
  <div class="section">
  {#if lenex}
    <AthleteTable lenex={lenex}/>
  {/if}
  </div>
</main>
</HFWrap>

<!--pre>{JSON.stringify(lenex, null, 2)}</pre-->